var map = {
	"./brand/reduced": 198,
	"./brand/reduced.svg": 198,
	"./brand/regular": 199,
	"./brand/regular.svg": 199,
	"./favicons/favicon-16x16": 200,
	"./favicons/favicon-16x16.png": 200,
	"./favicons/favicon-32x32": 201,
	"./favicons/favicon-32x32.png": 201,
	"./favicons/favicon-96x96": 202,
	"./favicons/favicon-96x96.png": 202,
	"./menu/event_logo": 203,
	"./menu/event_logo.png": 203,
	"./menu/logo": 204,
	"./menu/logo.svg": 204,
	"./menu/user": 205,
	"./menu/user.svg": 205,
	"./spinner": 206,
	"./spinner.svg": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;